import React from 'react'
import {
  BEQUEUE_CONFIG_STATE_CANCELLED,
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_DISCARDED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RETRIED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  getAccountSmsCredits,
  getConfiguration,
  getQueuedSmsRecipientsCountby,
  getSendingsTotalCost,
  getSmsCosts,
  getSmsSendingDetails,
  isSmsAliasAuthorized,
  setSendingType
} from '../actions/actions'
import {
  modalWarningAliasState,
  pageDataState,
  pageState,
  progressBarState
} from '../states/state'
import {
  toastShow,
  Link,
  TOAST_VARIANT_WARNING,
  PROGRESSBAR_VARIANT_DEFAULT,
  PROGRESSBAR_VARIANT_SUCCESS,
  PROGRESSBAR_VARIANT_ERROR
} from 'mailup-web-components'
import {
  ABTEST_STATUS_CONFIGURATION,
  ABTEST_STATUS_ENQUEUING,
  ABTEST_STATUS_PRE_ENQUEUING
} from 'Api/beABTestApi'
import {
  evalCondition,
  notifyParent,
  STORE_KEY_ACCOUNT
} from 'mailup-react-helpers'

import { isAlphanumeric } from 'Helpers/regEx'
import { storeGet } from 'Helpers/localStorage'

export const resetCallback = ({ set, reset }) => async id => {
  reset(pageState)
  reset(pageDataState)
  reset(progressBarState)
  reset(modalWarningAliasState)
}

export const initCallback = ({ snapshot, set }) => async (
  idInvio,
  idSms,
  idConfiguration
) => {
  set(pageState, prev => ({
    ...prev,
    loading: true,
    error: false,
    idSms,
    idInvio,
    idConfiguration
  }))

  try {
    // const [items] = await Promise.all([
    //   // getConfiguration(idConfiguration),
    //   getAccountSmsCredits(),
    //  getSmsCosts()
    // ])

    const smsCreditsResp = await getSmsCosts()

    set(pageDataState, prev => ({
      ...prev,
      Items: smsCreditsResp.Items
    }))
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
}

export const getQueueProgressCallback = ({ set, snapshot }) => async (
  idConfiguration,
  idInvio
) => {
  try {
    const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
    if (idConfiguration > 0) {
      const res = await getConfiguration(idConfiguration)
      const queuedPercentage = !res.ToBeQueued
        ? 0
        : (res.Queued / res.ToBeQueued) * 100

      set(progressBarState, {
        queueStatus: res.State,
        variant:
          queuedPercentage >= 100
            ? PROGRESSBAR_VARIANT_SUCCESS
            : PROGRESSBAR_VARIANT_DEFAULT,
        queuedPercentage: queuedPercentage,
        toBeQueued: res.ToBeQueued,
        processGlobalStatus: queuedPercentage <= 100
      })
      if (res.State === BEQUEUE_CONFIG_STATE_COMPLETED) {
        set(progressBarState, {
          queueStatus: BEQUEUE_CONFIG_STATE_COMPLETED,
          variant: PROGRESSBAR_VARIANT_SUCCESS,
          queuedPercentage: 100,
          toBeQueued: res.ToBeQueued,
          processGlobalStatus: false
        })

        const [
          sendingsTotalCost,
          sendingDetails,
          smsCredits
        ] = await Promise.all([
          getSendingsTotalCost(idInvio),
          getSmsSendingDetails(idInvio),
          getAccountSmsCredits()
        ])

        set(pageDataState, prev => ({
          ...prev,
          SendingsTotalCost: sendingsTotalCost.TotalCost,
          CountRecipientsToBeQueued: res.ToBeQueued,
          TotalCredits: smsCredits.TotalCredits
        }))
        if (
          parseInt(sendingsTotalCost.TotalCost) >
          parseInt(smsCredits.TotalCredits)
        ) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.QueueSms.trafficoGenerato'
            }),
            PROGRESSBAR_VARIANT_ERROR,
            'trafficoGenerato'
          )
        }
        try {
          if (sendingDetails.Sender && evalCondition('co:SMSALIAS')) {
            if (!isAlphanumeric.test(sendingDetails.Sender)) {
              const isSmsAliasAuthorizedResp = await isSmsAliasAuthorized(
                sendingDetails.Sender
              )

              if (!isSmsAliasAuthorizedResp.Authorized) {
                const getQueuedSmsRecipientsCountbyResp = await getQueuedSmsRecipientsCountby(
                  idInvio,
                  {
                    prefix: 39,
                    allowedsent: true
                  }
                )
                set(pageDataState, prev => ({
                  ...prev,
                  RecipientsReachedWithoutAlias:
                    getQueuedSmsRecipientsCountbyResp.Count
                }))

                if (getQueuedSmsRecipientsCountbyResp.Count > 0) {
                  if (IsTrial) {
                    toastShow(
                      getIntl().formatMessage({
                        id: 'Load.WarningAlias.WarningCountingTrial'
                      }),
                      TOAST_VARIANT_WARNING,
                      'WarningCountingTrial'
                    )
                  } else {
                    if (evalCondition('uo:SETTINGS')) {
                      toastShow(
                        <>
                          {getIntl().formatMessage(
                            {
                              id: 'Load.WarningAliasSms.WarningCountingNew'
                            },
                            {
                              X: getQueuedSmsRecipientsCountbyResp.Count,
                              linebreak: <br />,
                              link1: chunks => (
                                <Link
                                  onClick={() =>
                                    goToSettings(sendingDetails.Sender)
                                  }
                                >
                                  {chunks}
                                </Link>
                              ),
                              link2: chunks => (
                                <Link onClick={() => goToQueueSms(idInvio)}>
                                  {chunks}
                                </Link>
                              )
                            }
                          )}
                        </>,
                        TOAST_VARIANT_WARNING,
                        'WarningCountingNew'
                      )
                    } else {
                      toastShow(
                        <>
                          {getIntl().formatMessage(
                            {
                              id:
                                'Load.WarningAliasSms.WarningCountingNoPermissionNew'
                            },
                            {
                              X: getQueuedSmsRecipientsCountbyResp.Count,
                              linebreak: <br />,
                              link: chunks => (
                                <Link onClick={() => goToQueueSms(idInvio)}>
                                  {chunks}
                                </Link>
                              )
                            }
                          )}
                        </>,
                        TOAST_VARIANT_WARNING,
                        'WarningCountingNoPermissionNew'
                      )
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.QueueSms.CountRecipientsReachedWithoutAliasError'
            }),
            TOAST_VARIANT_WARNING,
            'CountRecipientsReachedWithoutAliasError'
          )
        }
      } else if (
        res.State === BEQUEUE_CONFIG_STATE_FAILED ||
        res.State === BEQUEUE_CONFIG_STATE_DISCARDED ||
        res.State === BEQUEUE_CONFIG_STATE_RETRIED ||
        res.State === BEQUEUE_CONFIG_STATE_CANCELLED
      ) {
        set(progressBarState, {
          queueStatus: res.State,
          variant: PROGRESSBAR_VARIANT_ERROR,
          queuedPercentage: queuedPercentage,
          toBeQueued: res.ToBeQueued,
          processGlobalStatus: false
        })

        toastShow(
          <>
            <span>
              {getIntl().formatMessage({
                id: 'Load.QueueSms.AlertDisallineamento'
              })}
            </span>
            <span> </span>
            <span>
              {getIntl().formatMessage(
                {
                  id: 'Load.QueueSms.GoToSendStatusSmsNew'
                },
                {
                  link: val => (
                    <Link onClick={() => goToSchedulation()}>{val}</Link>
                  )
                }
              )}
            </span>
          </>,
          TOAST_VARIANT_WARNING,
          'CountRecipientsReachedWithoutAliasError'
        )
      }
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'Sms Queue',
      Method: 'getQueueProgressCallback',
      Message: 'Errore in getQueueProgressCallback'
    })
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }
  set(pageState, prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
}

const goToSettings = sender => {
  notifyParent('redirectMainFrame', [
    'settings_app_redirector.aspx?r=/settings/smsalias/0/' + sender
  ])
}

const goToQueueSms = idInvio => {
  notifyParent('redirectMainFrame', [
    'queue_SMS.aspx?source=smssendstat&idInvio=' + idInvio + '&sendPreview=true'
  ])
}

const goToSchedulation = () => {
  notifyParent('redirectMainFrame', ['schedulation_SMS.aspx'])
}

export const startCallback = ({ snapshot, set }) => async (
  idInvio,
  idSms,
  sendingType
) => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))

  try {
    const resp = await setSendingType(idInvio, {
      IdSms: +idSms,
      SendingType: sendingType
    })
    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
    set(modalWarningAliasState, prev => ({
      ...prev,
      show: false
    }))

    switch (resp.Result) {
      case 0:
        notifyParent('redirectMainFrame', [`schedulation_SMS.aspx`])
        break
      case 1:
        toastShow(
          getIntl().formatMessage({
            id: 'Load.QueueSms.trafficoGenerato'
          }),
          'error',
          'trafficoGenerato'
        )
        break
      case 2:
        toastShow(
          getIntl().formatMessage({
            id: 'Load.QueueSms.msgRicalcola'
          }),
          'error',
          'msgRicalcola'
        )
        break
      default:
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.ErrorGeneric'
          }),
          'error',
          'sendErrorGeneric'
        )
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
    set(modalWarningAliasState, prev => ({
      ...prev,
      show: false
    }))
  }
}
